package pl.decks.personal.extensions

import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyleVariant


fun <K : ComponentKind> CssStyleVariant<K>.thenIf(
    condition: Boolean,
    next: CssStyleVariant<K>,
) = if (condition) this.then(next) else this
